import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  concat,
  defaultDataIdFromObject,
  gql,
} from "@apollo/client";
import { onError } from "@apollo/link-error";
import moment from "moment";
import { logout } from "data/helpers";
import { config } from "config";

const httpLink = createHttpLink({
  uri: config.graphqlUrl,
  credentials: "include",
});

// Checking for Auth errors in the GQL response
const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.every(({ extensions }) => {
      if (
        extensions &&
        extensions.code &&
        ["UNAUTHENTICATED"].includes(extensions.code.toUpperCase())
      ) {
        logout();
        return false;
      }

      return false;
    });
  }
});

const resolvers: any = {
  FuelTracker: {
    checked: (voucher: any) => voucher.selected || false,
  },
  Mutation: {
    toggleChecked: (_: any, args: any, ctx: any) => {
      const id = ctx.getCacheKey({
        voucherid: args.id,
        __typename: "FuelTracker",
      });
      const fragment = gql`
        fragment voucherSelect on FuelTracker {
          checked
        }
      `;
      const voucher = ctx.cache.readFragment({ fragment, id });
      const data = { checked: !voucher.checked };
      ctx.cache.writeFragment({ id, fragment, data });
      return null;
    },
  },
};

const cache = new InMemoryCache({
  typePolicies: {
    FuelTrackerStock: {
      keyFields: ["stknum", "clientid"],
    },
  },
  dataIdFromObject: (object: any) => {
    switch (object.__typename) {
      case "VehicleMakes":
        return object.MakeID;
      case "FuelTracker":
        return object.voucherid;
      default:
        return defaultDataIdFromObject(object);
    }
  },
});

export const client = new ApolloClient({
  cache,
  link: concat(errorLink, httpLink),
  resolvers,
});

cache.writeQuery({
  query: gql`
    {
      dates @client {
        startDate
        endDate
      }
      recapDates @client {
        startDate
        endDate
      }
      modal @client {
        visible
        modalType
        image
      }
      createMenu @client {
        visible
      }
    }
  `,
  data: {
    dates: {
      __typename: "CalendarDates",
      startDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    modal: {
      __typename: "ModalProperties",
      visible: false,
      modalType: "",
      image: "",
    },
    createMenu: {
      __typename: "CreateVoucherModal",
      visible: false,
    },
  },
});
